<template>
  <v-container v-if="link"
               fluid>
    <page-title icon="fas fa-fw fa-share-alt">
      Edit Shared Link
      <template v-slot:buttons>
        <v-chip v-if="link.is_active"
                color="success"
                label>
          Active
        </v-chip>
        <v-chip v-else-if="link.is_canceled || link.is_inactive"
                color="warning"
                label>
          Inactive
        </v-chip>
        <v-chip v-else-if="link.is_expired"
                color="warning"
                label>
          Expired
        </v-chip>
      </template>
    </page-title>
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card class="mb-4">
        <v-card-text>
          <shared-link-form :form="form"
                            :link="link"
                            @updated="$emit('updated')">
          </shared-link-form>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Update
          </v-btn>
          <v-btn v-if="link.is_active"
                 color="error"
                 @click.prevent="deactivate">
            Deactivate
          </v-btn>
          <v-btn v-else
                 color="success"
                 @click.prevent="activate">
            Reactivate
          </v-btn>
          <v-btn text
                 @click.prevent="$router.back()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="1===2"
                 color="error">
            Delete this link
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import SharedLinkForm from './components/SharedLinkForm.vue';
import moment from 'moment-timezone';
import sharedLinkService from '../../../../ml/services/sharedLinkService';
import DOMPurify from 'dompurify';
import slugify from 'slugify';

function initForm(link) {
  return {
    alias: link.alias, // MLD-1235
    name: link.name,
    expires_at: (link.expires_at) ? moment(link.expires_at).format('YYYY-MM-DD') : '',
    link_expires: link.expires_at ? true : false,
    notification_level: link.notification_level,
    display_user_info: link.display_user_info, // MLD-1103
    cc_recipients: link.cc_recipients ? link.cc_recipients : [], // MLD-1530
    user_id: link.user_id, // MLD-1635
    custom_javascript: link.custom_javascript, // MLD-1652
    facebook_pixel: link.facebook_pixel, // MLD-1652
    google_analytics_id: link.google_analytics_id, // MLD-1652
    linkedin_pixel: link.linkedin_pixel, // MLD-1652
    notifications: link.notifications, // MLD-1797
    target_url: link.target_url, // MLD-2295
  }
}

export default {
  components: {SharedLinkForm, PageTitle},
  props: {
    link: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      busy: false,
      form: new Form(initForm(this.link)),
    }
  },
  computed: {
    linkID() {
      return parseInt(this.$route.params.linkID);
    },
  },
  created() {

  },
  methods: {
    activate() {
      if (confirm('Are you sure you want to reactivate this link?')) {
        sharedLinkService.activate(this.link.id)
            .then(data => {
              this.$toast.success('Link reactivated.');
              this.$emit('updated');
            })
            .catch(err => {
              this.$toast.error(DOMPurify.sanitize(err.response.data.message));
            })
      }
    },
    deactivate() {
      if (confirm('Are you sure you want to deactivate this link?')) {
        sharedLinkService.cancel(this.link.id)
            .then(data => {
              this.$toast.success('Link deactivated.');
              this.$emit('updated');
            })
            .catch(err => {
              this.$toast.error(DOMPurify.sanitize(err.response.data.message));
            })
      }
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      if (this.form.alias) { // MLD-1235
        this.form.alias = slugify(this.form.alias, {lower: true});
      }
      if (this.form.link_expires === false) {
        this.form.expires_at = null;
      }
      const data = this.form.data();
      this.form.patch(`/api/shared-links/${this.link.id}`, {data})
          .then(response => {
            this.$toast.success('Link updated.');
            this.$emit('updated');
            this.$router.push({name: 'admin.shared_links.index'});
          })
          .catch(err => {

          })
    },
  }
}
</script>
